<template>
  <el-row class="canceledorder_framework">
<!--    <el-row class="canceledorder_framework" v-infinite-scroll="load">-->
    <el-container>
      <el-header height="120px">
        <div class="key_filter">
          <el-input class="filter_input" v-model="filterKey" placeholder="订单编号/手机号"></el-input>
          <el-button class="filter_button" type="primary" @click="getOrderListByKey">查询</el-button>
        </div>
        <div class="date_filter">
          <order-filter @changeData="changeData"></order-filter>
        </div>
      </el-header>
      <el-main v-loading="loading">
        <el-card v-for="(item,i) in orderList" :key=i class="order_card" shadow="hover">
          <el-row>
            <div class="clearfix">
              <el-col :span="16">
                <el-row>
                  <el-col :span="24">
                    <p class="order_title">已取消订单&nbsp;#{{item.id.substring(item.id.length-4)}}</p>
                  </el-col>
                  <el-col :span="24">
                    <p class="order_address">{{item.addressDetail + '--' + item.addressNote}}</p>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="8">
                <el-button class="order_status" type="text" disabled>
                  <span>已取消</span>
                </el-button>
              </el-col>
            </div>
          </el-row>
          <el-divider></el-divider>
          <order-card :orderInfo=item :inTheEnd=true></order-card>
        </el-card>
      </el-main>
    </el-container>
  </el-row>
</template>

<script>
  import OrderCard from "../OrderCard.vue"
  import OrderFilter from "../OrderFilter.vue"
  import DataUntils from "@/utils/data.js";

  export default {
    name: "CanceledOrder",
    components: {
      OrderCard,
      OrderFilter
    },
    data() {
      return {
        orderStatus: {
          status: "已取消"
        },
        orderList: [],
        filterKey: "",
        // 请求数据
        requestData: {
          startTime: (new Date()).getTime() - 3600 * 1000 * 24 * 7, // 开始日期
          status: "已取消", //订单状态
          endTime: new Date().getTime(), // 结束日期
          page: 1,
          pageSize: 2147483647,
        },
        loading: true,
      };
    },
    created() {
      this.getOrderList()
    },
    mounted() {},
    methods: {
      getOrderList() {
        this.loading = true;
        if (this.requestData.startTime == 0 && this.requestData.endTime == 0) {
          DataUntils
            .getOrderListByStatus({
              startTime: this.requestData.startTime,
              status: this.requestData.status,
            })
            .then((res) => {
              this.orderList = res.orderList;
              this.loading = false;
            })
        }
        else {
          DataUntils
            .getOrderListByStatus(this.requestData)
            .then((res) => {
              this.orderList = res.orderList;
              this.loading = false;
            })
        }
      },
      getOrderListByKey() {
        this.loading = true;
        if (this.requestData.startTime == 0 && this.requestData.endTime == 0) {
          DataUntils
            .getOrderListByStatus({
              key: this.filterKey,
              startTime: this.requestData.startTime,
              status: this.requestData.status,
            })
            .then((res) => {
              this.orderList = res.orderList;
              this.loading = false;
            })
        }
        else {
          DataUntils
            .getOrderListByStatus(Object.assign({ key: this.filterKey, }, this.requestData))
            .then((res) => {
              this.orderList = res.orderList;
              this.loading = false;
            })
        }
      },
      // 选择器change时，触发
      changeData(val) {
        this.requestData.startTime = val.startTime;
        this.requestData.endTime = val.endTime;
      },
    },
  };
</script>

<style>
  @import "../../../../style/Order.css";
  .el-loading-mask{
    margin: 20px;
  }
</style>
